export const permissions = {
    AOI_VIEW: 'AOI_VIEW',
    AOI_VIEW_LINE: 'AOI_VIEW_LINE',
    AOI_DRAW: 'AOI_DRAW',
    AOI_DRAW_LINE: 'AOI_DRAW_LINE',
    MAP_VIEW: 'MAP_VIEW',
    I2D_CREATE: 'I2D_CREATE',
    EMERGENCY_I2D_CREATE: 'EMERGENCY_I2D_CREATE',
    I2D_VIEW: 'I2D_VIEW',
    ADMIN_PORTAL_VIEW: 'ADMIN_PORTAL_VIEW',
    OBSERVATIONS_CREATE: 'OBSERVATIONS_CREATE',
    OBSERVATIONS_VIEW: 'OBSERVATIONS_VIEW',
    OBSERVATIONS_UPDATE: 'OBSERVATIONS_UPDATE',
    OBSERVATIONS_DELETE: 'OBSERVATIONS_DELETE',
    REPORTS_VIEW: 'DASHBOARD_VIEWER',
    ENQUIRY_CREATE: 'ENQUIRY_CREATE',
    ENQUIRY_VIEW: 'ENQUIRY_VIEW',
    ENQUIRY_UPDATE: 'ENQUIRY_UPDATE',
    ENQUIRY_DELETE: 'ENQUIRY_DELETE'
};
